import { useLocale, useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import type { ImageProps } from '@/app/components/Image';
import Image from '@/app/components/Image';

export interface AppUIImageProps extends ImageProps {
  readonly dimensionsByLocale?:
    | Record<
        string,
        {
          height: number;
          width: number;
        }
      >
    | undefined;
  readonly src: MessageKey;
}

const AppUIImage = ({ dimensionsByLocale, src, ...props }: AppUIImageProps) => {
  const t = useTranslations();
  const locale = useLocale();
  return (
    <Image
      {...props}
      {...dimensionsByLocale?.[locale]}
      alt=""
      data-cy="app_ui_image"
      src={t(src)}
    />
  );
};

export default AppUIImage;
